<!-- CustomModal.svelte -->
<script>
	import FakeButton from "./FakeButton.svelte";
	import Button from "./Button.svelte";

	export let title = "";
	export let colorTheme = "primary"; // Padrão no tema de cor primário
	export let onCancel = () => {};
	export let onContinue = () => {};
</script>

<div class="modal-overlay" on:click={onCancel} on:keypress></div>

<div class={`custom-modal`}>
	<div class="modal-header">
		<h2>{title}</h2>
		<FakeButton iconName="vector" onClick={onCancel} />
	</div>
	<div class="modal-body">
		<slot name="body"></slot>
	</div>
	<div class="modal-footer">
		<Button
			handleClick={onCancel}
			variant="button-light"
			label="Cancelar"
		/>
		<Button
			handleClick={onContinue}
			label="Sim, finalizar"
			variant={colorTheme}
		/>
	</div>
</div>

<style>
	.modal-overlay {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.5);
		z-index: 999;
	}

	.custom-modal {
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		background: white;
		border-radius: 16px;
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
		width: 40%;
		min-width: 400px;
		max-width: 700px;
		max-height: 60%;
		z-index: 1000;
		display: flex;
		flex-direction: column;
	}

	.modal-header,
	.modal-footer {
		flex-shrink: 0;
	}

	.modal-header {
		display: flex;
		padding: 30px;
		border-bottom: 1px solid #d3cfcf;
		align-items: center;
		justify-content: space-between;
		color: #000000b2;
		font-size: 22px;
		font-weight: 600;
	}
	.modal-body {
		display: flex;
		padding: 30px;
		border-bottom: 1px solid #d3cfcf;
		min-height: 65px;
		align-items: center;
		flex-shrink: 1;
		overflow-y: auto;
		color: #2b2b2b;
	}
	.modal-footer {
		display: flex;
		justify-content: flex-end;
		padding: 30px;
		gap: 2rem;
	}
	:global(.modal-body p) {
		margin-block-start: 0;
		margin-block-end: 0.5em;
		margin-inline-start: 0;
		margin-inline-end: 0;
		font-weight: 400;
		font-size: 13px;
	}

	.modal-body::-webkit-scrollbar {
		width: 8px;
	}

	.modal-body::-webkit-scrollbar-track {
		background: transparent;
	}

	.modal-body::-webkit-scrollbar-thumb {
		background: rgba(0, 0, 0, 0.2);
		border-radius: 4px;
	}

	.modal-body::-webkit-scrollbar-thumb:hover {
		background: rgba(0, 0, 0, 0.3);
	}

	.modal-body {
		scrollbar-width: thin;
		scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
	}

	/* TABLET (768px - 1023px) */
	@media (max-width: 1023px) {
		.custom-modal {
			width: min(560px, 88vw);
			min-width: min(400px, 88vw);
			max-height: 80vh;
			max-height: 80dvh;
		}

		.modal-header,
		.modal-body,
		.modal-footer {
			padding: 24px;
		}
	}

	/* MOBILE (< 768px) */
	@media (max-width: 767px) {
		.custom-modal {
			width: calc(100% - 32px);
			min-width: 0;
			max-width: 440px;
			max-height: 85vh;
			max-height: 85dvh;
			border-radius: 12px;
		}

		.modal-header {
			padding: 16px 18px;
			font-size: 18px;
		}

		.modal-body {
			padding: 16px 18px;
		}

		.modal-footer {
			padding: 14px 18px;
			gap: 12px;
		}
	}
</style>
